import { formatDateForMessageDetail } from "@/components/messages/util.ts";
import type { HeavyArtifactResponse } from "@/types/artifacts.ts";
import { isArtifactFinalStatus, isTextDeliveryInFlight } from "./artifactUtils.ts";

/**
 * Status-aware date line for a heavy artifact:
 *   final status (completed/cancelled/sent/connected) → "<statusLabel> <date>"
 *   in-flight text delivery ("Sending") → same, since "Created" would erase the send
 *   received-style artifact (communication/invitation received, response) → "Received <date>"
 *   default → "Created <date>"
 *
 * Used in both the inline thread footer (`HeavyArtifactItem`) and the
 * lightbox footer (`HeavyArtifactLightbox`) so the two surfaces stay in sync.
 */
export const ArtifactStatusDate = ({ artifact }: { artifact: HeavyArtifactResponse }) => {
  if (isArtifactFinalStatus(artifact) || isTextDeliveryInFlight(artifact)) {
    const dateToUse = artifact.updatedAt ?? artifact.createdAt;
    return (
      <>
        {artifact.statusLabel} {formatDateForMessageDetail(dateToUse)}
      </>
    );
  }
  if (
    artifact.artifactType === "communicationReceived" ||
    artifact.artifactType === "invitationReceived" ||
    artifact.artifactType === "invitationResponse"
  ) {
    return <>Received {formatDateForMessageDetail(artifact.receivedAt)}</>;
  }
  return <>Created {formatDateForMessageDetail(artifact.createdAt)}</>;
};
